import React, { useState, useRef, useEffect } from 'react';
import Scene, { Hotspot } from 'threejs-scene';
import {useDispatch} from 'react-redux';
import ProductViewNew from  './ProductViewNew';
import './ZoomModal.css';
import 'threejs-scene/dist/main.css';

const cdnUrl = 'https://cdn.obsess-vr.com/vacheron/';
const closeIcon = cdnUrl + 'vac_xicon_white.svg';
const hostpotIcon = cdnUrl + 'zoomhotspoticon-v1.svg';

const ZoomModal = React.memo(({ status, params }) => {
    const dispatch = useDispatch();
    const [isShowingProductModal, setIsShowingProductModal] = useState(false);
    const [productSKU, setProductSKU] = useState(null);
    const [mounted, setMounted] = useState(false);
    const {scene,  hotspots, bgUrl } = params;



    useEffect(()=>{
        if(status && scene && !mounted) setMounted(true);

        return(() => {
            console.log('%c ZoomModal:scene unmounts', 'color:red');
        })
    }, [scene]);



    const onModalClose = () => {
        dispatch({type:'AP_MODAL_SET_STATUS', payload:{
                name:'ZoomModal',
                status:false,
            }});
    }

    const onProductModalClose = () => {
        setIsShowingProductModal(false);
    }

    const handleHotspotClick = (e, sceneObject, marker) =>{
        console.log('%c ZoomModal Scene clicked', 'color:blue', {sceneObject, marker});
        if(marker && marker.userData != undefined){
            console.log('%c Marker ', 'color:blue', {marker, sku:marker.userData.sku });
            setProductSKU(marker.userData.sku);
            setIsShowingProductModal(true);
        }  
    }




    return (
        <div id='zoomModal' className={status ? 'active':''} >

           {isShowingProductModal && <ProductViewNew
               productSKU={productSKU}
               onProductModalClose={onProductModalClose}
               isShowingProductModal={isShowingProductModal}
           />}

            <div id='zoomModalContainer' >
                <div id='closeIconContainer' onClick={onModalClose}>
                    <img id="close" src={closeIcon}/>
                </div>

                <div id='imageContainer'>
                    {mounted && <ThreeScene
                        scene={scene}
                        backgroundImage={ bgUrl }
                        handleHotspotClick={handleHotspotClick}
                        hotspots={hotspots}
                    />}
                </div>
            </div>
        </div>
    );
});




const ThreeScene = React.memo(({scene,  backgroundImage, hotspots, handleHotspotClick})=>{

    return (<Scene
        sceneId={scene}
        bgConf={{
            isFlatScene: true,
            backgroundUrl: backgroundImage,
        }}
        allowHotspotsToMove={false}
        onMouseUp={handleHotspotClick}
        onDrop={()=>{}}
        onDrag={() => {}}
        allowEventsForMarkerTypeOnly='hotspot_marker'
        resetBGBeforeImageLoaded={true}
    >
        {hotspots?.map((hotspot) => {
            const userData={}
            if(hotspot.props.hotspot_type == "product") userData.sku = hotspot.props.product_sku;
            return (
                <Hotspot
                    key={hotspot._id['$oid']}
                    type='hotspot'
                    collider_transform={hotspot.collider_transform}
                    transform={hotspot.transform}
                    userData={userData}
                    imageURL={hostpotIcon}
                    animation = "pulsing"
                />
            )
        })}
    </Scene>)
}, (prevProps, props)=>{
    const stateIsEqual = JSON.stringify(prevProps) == JSON.stringify(props);
    // console.log('-isChanged', {stateIsEqual, prevProps, props});
    return stateIsEqual;
});
  
export default ZoomModal;